module.exports = __webpack_public_path__ + "static/media/ico_ayuda.048269ca.png";